import React, { useEffect, useRef, useMemo } from "react";

import JsBarcode from "jsbarcode";

const ThermalBarcodeLabel = ({ data }) => {
  const barcodeRefs = useRef([]);

  const barcodeOptions = useMemo(
    () => ({
      format: "CODE128",
      lineColor: "#000000",
      width: 1.7, // Optimal thickness for scanning
      height: 35, // Reduced height for portrait layout
      displayValue: true,
      fontSize: 10,
      margin: 4,
      fontOptions: "bold",
    }),
    []
  );

  const expandedVariants = useMemo(() => {
    if (!data?.variants) return [];

    return data.variants.flatMap((variant) => {
      const quantity = Math.max(0, parseInt(variant.bar_quantity) || 0);
      return Array.from({ length: quantity }, (_, i) => ({
        ...variant,
        product_title: data.title || data.product_title || "Product",
        uniqueKey: `${variant.id}-${i}`,
        sequence: i + 1,
      }));
    });
  }, [data]);

  useEffect(() => {
    barcodeRefs.current.forEach((ref, index) => {
      try {
        if (ref && expandedVariants[index]?.barcode) {
          JsBarcode(ref, expandedVariants[index].barcode, barcodeOptions);
        }
      } catch (error) {
        console.error("Barcode generation error:", error);
      }
    });
  }, [expandedVariants, barcodeOptions]);

  return (
    <div
      className="portrait-labels"
      style={{
        width: "64mm",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>{`
        @page {
          size: 64mm 45mm;
          margin: 0;
        }
        body {
          margin: 0 !important;
          padding: 0 !important;
        
        }
        .label {
          width: 60mm;
          height: 41mm;
          display: flex;
          flex-direction: column;
          padding: 2mm;
          position: relative;
          box-sizing: border-box;
         //border-radius: 15px;
        //border: 1px dashed blue; 
          margin-bottom: 2mm;
          margin-left: 2mm;
          overflow: hidden;
          page-break-after: always;
         
        }
        
        .text-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
         
        }
        // .product-name {
        //   font-size: 9pt;
        //   font-weight: bold;
        //   margin-bottom: 1mm;
        //   line-height: 1;
        //   word-break: break-word;
        // }
        .product-name {
          font-size: 11pt;
          font-weight: bold;
          margin-bottom: 1mm;
          line-height: 1;
          /* Smart breaking that prefers whole words */
          overflow-wrap: break-word;  /* Breaks only if word would overflow */
          word-break: keep-all;      /* Prevents breaking within words */
          white-space: normal;       /* Ensures text wraps normally */
          /* Optional: Add these if you want to limit to 2 lines */
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .variant-details {
          font-size: 8pt;
          margin-bottom: -1.4mm;
        }
        .variant-title {
          font-size: 13pt;
          font-weight: bold;
          margin-bottom: 0mm;
        }
        
        .barcode-container {
          width: 100%;
          height: 20mm;
          display: flex;
          justify-content: center;
          align-items: center;
          
        }
        .footer-container {
          position: absolute; /* Changed to absolute */
      top: 38.6mm; 
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      width: 100%;
        
        }
        .web-small {
          font-size: 6pt;
          font-weight: bold;
          text-align: center;
        }
        .sequence-number {
          position: absolute;
          right: 2mm;
          font-size: 5pt;
          font-weight: bold;
        }
      `}</style>

      {expandedVariants.map((variant, index) => (
        <div key={variant.uniqueKey} className="label p3">
          <div className="text-content">
            <div className="product-name">{variant.product_title}</div>

            <div className="variant-title">Size {variant.title}</div>
            <div className="variant-details">{variant.sku}</div>
          </div>

          <div className="barcode-container">
            <svg
              ref={(el) => (barcodeRefs.current[index] = el)}
              aria-label={`Barcode for ${variant.sku}`}
            />
          </div>
          {/* <div style={{ fontSize: "5pt", textAlign: "center" }}>
            MRP {variant.price} +GST
          </div> */}
          <div className="footer-container">
            <p className="web-small">www.velvourshop.com</p>
            <span className="sequence-number">{index + 1}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
export default ThermalBarcodeLabel;
